module.exports = __webpack_public_path__ + "bb47cd7ae90d3fc593c2418581df102e.mp4";